/* app/js/src/components/user/common/user-form/user-personal-info/user-personal-info.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  width: 100%;
  display: flex;
  flex: 1;
}
input,
textarea {
  height: 30px;
  border-radius: 4px;
  background-color: #ffffff;
  font-size: 12px;
  border: solid 1px #e1e6eb;
  color: #232f3a;
  outline: none;
}
input ::-webkit-input-placeholder,
textarea ::-webkit-input-placeholder {
  color: #c9cdd6;
}
input[type=date],
textarea[type=date] {
  width: 180px;
}
input[type=date]::-webkit-inner-spin-button,
textarea[type=date]::-webkit-inner-spin-button {
  display: none;
}
.text {
  color: #232f3a;
}
.text .info {
  margin-top: 25px;
  font-size: 12px;
  color: #879baf;
}
.label {
  color: #232f3a;
  padding-right: 12px;
  font-size: 12px;
}
.btn-back {
  display: flex;
  align-items: center;
  cursor: pointer;
  float: right;
  margin-top: 45px;
}
.rounded-btn,
.rounded-btn-prev {
  display: inline-block;
  background: #f1f3f4 no-repeat center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
}
.rounded-btn-prev {
  margin-right: 10px;
}
.rounded-btn-next {
  margin-left: 10px;
  border: 0;
  margin-right: 0px;
}
.dropdown {
  width: 180px;
}
input,
textarea {
  padding: 0 12px 0 12px;
}
input ::-webkit-input-placeholder,
textarea ::-webkit-input-placeholder {
  color: #c9cdd6;
}
input[type=text],
textarea[type=text],
input[type=password],
textarea[type=password],
input[type=email],
textarea[type=email],
input[type=tel],
textarea[type=tel] {
  width: 180px;
}
input.ng-invalid.ng-dirty,
textarea.ng-invalid.ng-dirty,
input.ng-touched.ng-invalid,
textarea.ng-touched.ng-invalid {
  border-bottom: 2px solid red;
}
input.ng-valid.ng-dirty,
textarea.ng-valid.ng-dirty {
  border-bottom: 2px solid greenyellow;
}
textarea {
  resize: none;
  padding-top: 5px;
}
.text-area-large {
  height: 110px;
}
.text {
  margin: 8px 0 20px 0;
}
.user-form {
  margin: 0 auto;
  margin-top: 110px;
}
.content .red {
  color: red;
  position: relative;
  bottom: 4px;
  left: 4px;
}
.content table {
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0.1px;
  border-collapse: separate;
  border-spacing: 40px 0px;
}
.content table .table-header {
  font-size: 14px;
}
.content table th,
.content table td {
  height: 52px;
}
.content table th.long,
.content table td.long {
  width: 225px;
}
.content table th.short,
.content table td.short {
  width: 100px;
}
.content table th.very-short,
.content table td.very-short {
  width: 70px;
}
.content table .field-title {
  color: #232f3a;
}
.content .errorMsg {
  display: block;
  color: red;
  font-size: 9px;
  position: absolute;
  margin: 4px 0;
}
.create-new-tenant-btn {
  color: #232f3a;
}
/*# sourceMappingURL=user-personal-info.component.css.map */
